////////////////////////////////////
//          HOME ICON             //
////////////////////////////////////

let homeElem = document.querySelector("#homeIcon");
let homeIcon = new Zdog.Illustration({
  element: homeElem,
  hover: true,
  scale: 0.5,
});

let house = new Zdog.Group({
  addTo: homeIcon,
  translate: { y: 50 },
});

let zAnchor = new Zdog.Anchor({
  addTo: house,
  translate: { z: 30 },
});

let faceAvant = new Zdog.Group({
  addTo: zAnchor,
});

let faceArriere = new Zdog.Group({
  addTo: zAnchor,
  translate: { z: -60 },
});

new Zdog.Shape({
  addTo: faceAvant,
  path: [
    { x: -30, y: 0 }, // start at 1st point
    {line:{ x: 30, y: 0 }}, // line to 2nd point
    {move:{ x: -30, y: 0 }}, // move to 3rd point
    {line:{ x: -50, y: -60 }}, // line to 3rd point
    {move:{ x: 30, y: 0 }}, // move to 3rd point
    {line:{ x: 50, y: -60 }}, // line to 3rd point
  ],
  stroke: 2,
});

new Zdog.Shape({
  addTo: faceAvant,
  path:[
    {x:0, y:-100},
    {line:{x:-60, y:-52}},
  ],
  stroke: 2,
})

new Zdog.Shape({
  addTo: faceArriere,
  path: [
    { x: -30, y: 0 }, // start at 1st point
    {line:{ x: 30, y: 0 }}, // line to 2nd point
    {move:{ x: 30, y: 0 }}, // move to 3rd point
    {line:{ x: 50, y: -60 }}, // line to 3rd point
  ],
  stroke: 2,
});

let anchorToit = new Zdog.Anchor({
  addTo: house,
  rotate: {y: Zdog.TAU/4 },
});

let rectFill = new Zdog.Rect({
  addTo: anchorToit,
  width: 50,
  height: 65,
  rotate: {x: -0.90 },
  translate: { z:-30,y: -76 },
  stroke: 2,
  fill: true,
  color: '#dad4d4',
});

let rect = new Zdog.Rect({
  addTo: anchorToit,
  width: 60,
  height: 75,
  rotate: {x: -0.90 },
  translate: { z:-30,y: -76 },
  stroke: 2,
  color: '#001133',
});

//relie les deux faces
new Zdog.Shape({
  addTo: zAnchor,
  path:[
    {x:-30, y:0, z:0},
    {line:{x:-30, y:0, z:-60}},
  ],
  stroke: 2,
});

new Zdog.Ellipse({
  addTo: zAnchor,
  diameter: 35,
  stroke: 2,
  translate: { y: -60 },
  color: '#EA4536',
});

let perchoir= new Zdog.Ellipse({
  addTo: zAnchor,
  diameter: 10,
  stroke: 2,
  quarters: 2,
  translate: { y: -20, z: 0},
  color: '#EA4536',
});

perchoir.copy({
  quarters: 4,
  translate: {y:-20, z: 20 },
});

//relie les deux perchoirs
new Zdog.Shape({
  addTo: zAnchor,
  path:[
    {x:0, y:-25, z:0},
    {line:{x:0, y:-25, z:20}},
    {move:{x:0, y:-15, z:0}},
    {line:{x:0, y:-15, z:20}},
  ],
  stroke: 2,
  color: '#EA4536',
});

new Zdog.Shape({
  addTo: zAnchor,
  path:[
    {x:0, y:-100, z:-30},
    {line:{x:0, y:-120, z:-30}},
  ],
  stroke: 2,
});

export {homeIcon};

////////////////////////////////////
//          FIN HOME ICON         //
////////////////////////////////////

////////////////////////////////////
//          TIER-LIEU ICON        //
////////////////////////////////////
let tierLieuElem = document.querySelector("#tierLieuIcon");
let tierLieuElemTitle = document.querySelector("#tierLieuTitle");

let tierLieuIcon = new Zdog.Illustration({
  element: tierLieuElem,
  scale: 0.4,
});

let tierLieuTitle = new Zdog.Illustration({
  element: tierLieuElemTitle,
  scale: 0.4,
});

let tierLieuGroup = new Zdog.Group({
  addTo: tierLieuIcon,
});

let tierLieuTitleGroup = new Zdog.Group({
  addTo: tierLieuTitle,
});

let puzzle1 = new Zdog.Shape({
  addTo: tierLieuGroup,
  closed: false,
  path: [
    { x: 0, y: 0, z:30 }, // start at 1st point
    { x: 25, y: 0, z:30 }, // line to 2nd point
    {arc: [
        { x: 25, y: 15, z:30 }, // corner
        { x: 37.5, y: 15, z:30 }, // end point
      ]},
    {arc: [
        { x: 50, y: 15, z:30 }, // corner
        { x: 50, y: 0, z:30 }, // end point
      ]},
    { x: 75, y: 0, z:30 }, // line to 2nd point
    {arc: [
        { x: 75, y: -75, z:30 }, // corner
        { x: 0, y: -75, z:30 }, // end point
      ]},
    { x: 0, y: -50, z:30 }, // line to 2nd point
    {arc: [
        { x: 15, y: -50, z:30 }, // corner
        { x: 15, y: -37.5, z:30 }, // end point
      ]},
    {arc: [
        { x: 15, y: -25, z:30 }, // corner
        { x: 0, y: -25, z:30 }, // end point
      ]},
    { x: 0, y: 0, z:30 }, // line to 2nd point
  ],
  stroke: 2,
  color: '#001133',
})

puzzle1.copy({
  rotate: { z: Zdog.TAU/4 },
  color: '#001133',
});

puzzle1.copy({
  rotate: { z: Zdog.TAU/2 },
  color: '#001133',
});

puzzle1.copy({
  rotate: { z: 3*Zdog.TAU/4 },
  color: '#ea4536',
});

puzzle1.copy({
  addTo: tierLieuTitleGroup,
});

puzzle1.copy({
  addTo: tierLieuTitleGroup,
  rotate: { z: Zdog.TAU/4 },
  color: '#001133',
});

puzzle1.copy({
  addTo: tierLieuTitleGroup,
  rotate: { z: Zdog.TAU/2 },
  color: '#001133',
});

puzzle1.copy({
  addTo: tierLieuTitleGroup,
  rotate: { z: 3*Zdog.TAU/4 },
  color: '#ea4536',
});

let ellipseTier = new Zdog.Ellipse({
  addTo: tierLieuGroup,
  diameter: 150,
  stroke: 2,
  translate: { z: -30 },
  quarters: 2,
  color: '#001133',
});

ellipseTier.copy({
  addTo: tierLieuTitleGroup,
});

let bosseTier = new Zdog.Shape({
  addTo: tierLieuGroup,
  path: [
    { x: 0, y: -75, z: -30 }, // start at 1st point
    { x: 0, y: -75, z: 30 }, // line to 2nd point
  ],
  stroke: 2,
  color: '#ea4536',
});

let bosseTier2 = new Zdog.Shape({
  addTo: tierLieuGroup,
  path: [
    { x: 0, y: 75, z: -30 }, // start at 1st point
    { x: 0, y: 75, z: 30 }, // line to 2nd point
    {move: { x: 75, y: 0, z: 30 }},
    {line: { x: 75, y: 0, z: -30 }},
  ],
  stroke: 2,
  color: '#011133',
});

bosseTier.copy({
  addTo: tierLieuTitleGroup,
})

bosseTier2.copy({
  addTo: tierLieuTitleGroup,
});

export {tierLieuIcon, tierLieuTitle};

////////////////////////////////////
//          FIN TIER-LIEU ICON    //
////////////////////////////////////

////////////////////////////////////
//          COM ICON              //
////////////////////////////////////

let comElem = document.querySelector('#comIcon');
let comElemTitle = document.querySelector('#comIconTitle');
let comIcon = new Zdog.Illustration({
  element: comElem,
  scale: 0.14,
  translate:{y: 5},
})

let comTitle = new Zdog.Illustration({
  element: comElemTitle,
  scale: 0.14,
  translate:{y: 5},
})

let comGroup = new Zdog.Group({
  addTo: comIcon,
});

let comTitleGroup = new Zdog.Group({
  addTo: comTitle,
});

let bird = new Zdog.Group({
  addTo:comGroup,
  translate: {x: 150,y:-50, z:-10},
  rotate: {y: -Zdog.TAU/4},
})

let birdTitle = new Zdog.Group({
  addTo:comTitleGroup,
  translate: {x: 150,y:-50, z:-10},
  rotate: {y: -Zdog.TAU/4},
})

let megaphoneAmpli = new Zdog.Shape({
  addTo: comGroup,
  path:[
    {x:120, y:-220,z:0},{x:-10, y:-170,z:0},{x:-10, y:-50,z:0},{x:120, y:20,z:0},

    {move:{x:-40,y:-170,z:0}},{x:-150,y:-170,z:0},{x:-150,y:-50,z:0},{x:-40,y:-50,z:0},{x:-40,y:-170,z:0},

    {move:{x:-40,y:-20,z:0}},{x:-100 ,y:-20,z:0},{x:-70 ,y:80,z:0},{x:-10 ,y:80,z:0},{x:-40,y:-20,z:0}
  ],
  closed:false,
  stroke:3,color:'#001133',
  translate:{y:50,z:70},
})

megaphoneAmpli.copy({
  addTo:comTitleGroup,
});

let bec = new Zdog.Shape({
  addTo: bird,
  path:[
    {x:130, y:-50,z:0},{x:200, y:-100,z:0},{x:140, y:0,z:0},{x:200, y:70,z:0},{x:130, y:50,z:0},

  ],
  closed:false,
  stroke:3,color:'#001133',
})

bec.copy({
  addTo: birdTitle,
});

let visage = new Zdog.Ellipse({
  addTo: bird,
  width: 240,height: 240,
  stroke:3,color: '#EA4536',

});

visage.copy({
  addTo: birdTitle,
});

//eye
visage.copy({
  width:20,height:20,
  translate:{x: 40,y:-30, z:0},
})

visage.copy({
  addTo: birdTitle,
  width:20,height:20,
  translate:{x: 40,y:-30, z:0},
})

export {comIcon, comTitle};

////////////////////////////////////
//          FIN COM ICON          //
////////////////////////////////////

////////////////////////////////////
//          MR ICON               //
////////////////////////////////////

let mrElem = document.querySelector("#mrIcon");
let mrElemTitle = document.querySelector("#mrIconTitle");

let mrIcon = new Zdog.Illustration({
  element: mrElem,
  scale: 0.4,
});

let mrTitle = new Zdog.Illustration({
  element: mrElemTitle,
  scale: 0.4,
});

let mrGroup = new Zdog.Group({
  addTo: mrIcon,
  translate: { y: 50 },
});

let mrTitleGroup = new Zdog.Group({
  addTo: mrTitle,
  translate: { y: 50 },
});

let head = new Zdog.Shape({
  addTo: mrGroup,
  closed: false,
  path: [
    { x: 75, y: 0, z:30 }, // start at 1st point
    // { x: 20, y: 0, z:30 }, // line to 2nd point
    {arc: [
        { x: 25, y: 10, z:30 }, // corner
        { x: 25, y: 0, z:30 }, // end point
      ]},
    {arc: [
        { x: 0, y: -30, z:30 }, // corner
        { x: -25, y: 0, z:30 }, // end point
      ]},
    {arc: [
        { x: -25, y: 10, z:30 }, // corner
        { x: -75, y: 0, z:30 }, // end point
      ]},
    {arc: [
        { x: -90, y: -25, z:30 }, // corner
        { x: -75, y: -60, z:30 }, // end point
      ]},
    {arc: [
        { x: -50, y: -75, z:30 }, // corner
        { x: 0, y: -75, z:30 }, // end point
      ]},
    {arc: [
        { x: 50, y: -75, z:30 }, // corner
        { x: 75, y: -60, z:30 }, // end point
      ]},
    {arc: [
        { x: 90, y: -25, z:30 }, // corner
        { x: 75, y: 0, z:30 }, // end point
      ]},
  ],
  translate: { x: 0, y: 0, z: -15 },
  stroke: 2,
  color: '#001133',
});

head.copy({
  addTo: mrTitleGroup,
});

let laniereDroite = new Zdog.Shape({
  addTo: mrGroup,
  closed: false,
  path: [
    { x: 80, y: -50, z: 15 }, // start at 1st point
    { x: 85, y: -50, z: -60 }, // line to 2nd point
    {move: { x: 82, y: -30, z: 15 }},
    {line: { x: 87, y: -30, z:  -60}},
    {arc: [
        { x: 85, y: -45, z: -70 }, // corner
        { x: 85, y: -50, z: -60 }, // end point
      ]},
  ],
  stroke: 2,
  color: '#ea4536',
});

laniereDroite.copy({
  addTo: mrTitleGroup,
});

let laniereGauche = new Zdog.Shape({
  addTo: mrGroup,
  closed: false,
  path: [
    { x: -80, y: -50, z: 15 }, // start at 1st point
    { x: -85, y: -50, z: 15 }, // line to 2nd point
    {move: { x: -82, y: -30, z:15 }},
    {line: { x: -87, y: -30, z:  15}},
    {arc: [
        { x: -85, y: -45, z: 15 }, // corner
        { x: -85, y: -50, z: 15 }, // end point
      ]},
  ],
  stroke: 2,
  color: '#ea4536',
});

laniereGauche.copy({
  addTo: mrTitleGroup,
});

let headPerspectiveFill = new Zdog.Shape({
  addTo: mrGroup,
  closed: false,
  path: [
    { x: 75, y: 0, z:30 }, // start at 1st point
    // { x: 20, y: 0, z:30 }, // line to 2nd point
    {arc: [
        { x: 40, y: 8, z:30 }, // corner
        { x: 40, y: 0, z:30 }, // end point
      ]},
    {arc: [
        { x: 0, y: -30, z:30 }, // corner
        { x: -40, y: 0, z:30 }, // end point
      ]},
    {arc: [
        { x: -40, y: 8, z:30 }, // corner
        { x: -75, y: 0, z:30 }, // end point
      ]},
    {arc: [
        { x: -90, y: -25, z:30 }, // corner
        { x: -75, y: -60, z:30 }, // end point
      ]},
    {arc: [
        { x: -50, y: -70, z:30 }, // corner
        { x: 0, y: -70, z:30 }, // end point
      ]},
    {arc: [
        { x: 50, y: -75, z:30 }, // corner
        { x: 75, y: -60, z:30 }, // end point
      ]},
    {arc: [
        { x: 90, y: -25, z:30 }, // corner
        { x: 75, y: 0, z:30 }, // end point
      ]},
  ],
  stroke: 2,
  scale: 0.7,
  fill: true,
  color: '#dad4d4',
  translate: { x: 0, y: -15, z: 30 },
});

headPerspectiveFill.copy({
  fill: false,
  stroke: 2,
  color: '#ea4536',
});

headPerspectiveFill.copy({
  addTo: mrTitleGroup,
});

headPerspectiveFill.copy({
  addTo: mrTitleGroup,
  fill: false,
  stroke: 2,
  color: '#ea4536',
});

export {mrIcon, mrTitle};

////////////////////////////////////
//          FIN MR ICON           //
////////////////////////////////////

///////////////////////////////////
/////// ICONE IMPRIMANTE 3D ///////
///////////////////////////////////

//Pour l'icone d'imprimante 3D
let fabIconElem = document.querySelector('#fabIcon');
let fabIconTitleElem = document.querySelector('#fabIconTitle');

let fabIcon = new Zdog.Illustration({
  element: fabIconElem,
  scale:0.3,
})

let fabIconTitle = new Zdog.Illustration({
  element: fabIconTitleElem,
  scale:0.3,
});

let Boitier3DPrintGroup = new Zdog.Group({
  addTo:fabIcon,
})

let Boitier3DPrintGroupTitle = new Zdog.Group({
  addTo:fabIconTitle,
});


let rectHide = new Zdog.Rect({
  addTo:Boitier3DPrintGroup,
  width:170,
  height:20,
  translate:{x: 0,y:-70, z:0},
  color:'#DAD4D4',
  fill:true,
})

let rectHideTitle = rectHide.copy({
  addTo:Boitier3DPrintGroupTitle,
});

let bed= new Zdog.Shape({
  addTo: Boitier3DPrintGroup,
  closed:false,
  path:[
    //BED
    {x: 60,y:50, z:60},{x: 60,y:50, z:-60}, {x: -60, y:50, z:-60},{x: -60, y:50, z:60},{x: 60,y:50, z:60},
  ],
  stroke: 2,
  color:'#001133',
})

bed.copy({
  addTo: Boitier3DPrintGroupTitle,
});

rectHide.copy({
  width:20,
  height:120,
  translate:{x: 70,y:0, z:0},
})

rectHideTitle.copy({
  width:20,
  height:120,
  translate:{x: 70,y:0, z:0},
})

rectHide.copy({
  width:20,
  height:120,
  translate:{x: 80,y:0, z:-10},
  rotate:{y: Zdog.TAU/4},
})

rectHideTitle.copy({
  width:20,
  height:120,
  translate:{x: 80,y:0, z:-10},
  rotate:{y: Zdog.TAU/4},
});

let boitier3d = new Zdog.Shape({
  addTo: Boitier3DPrintGroup,
  closed:false,
  path:[
    //ColonneGauche EFGHEIJK
    {move:{x: -60,y:60, z:0}},{x: -60,y: -60, z:0},{x: -80,y: -60, z:0},{x: -80,y: 60, z:0},
    {x: -60,y:60, z:0},{x:-60,y:60,z:-20},{x:-60,y:-60,z:-20},{x:-80,y:-60,z:-20},

    //ColonneDroite
    {move:{x: 60,y:60, z:0}},{x: 60,y: -60, z:0},{x: 80,y:-60, z:0},{x: 80,y: 60, z:0},
    {x: 60,y: 60, z:0},{x: 80,y:60, z:0},{x:80,y:60,z:-20},{x:80,y:-60,z:-20},
    {x:60,y:-60,z:-20},{x: 80,y:-60, z:-20},

    //Boitier
    {move:{x: 85,y:60,z:70}},{x:85,y:90,z:80},{x:85,y:90,z:-70},{x:85,y:60,z:-70},{x: 85,y:60,z:70},
    {x: -85,y:60,z:70},{x: -85,y:90,z:80},{x:85,y:90,z:80},

    //ecran
    {move:{x: 75,y:65,z:70}},{x:25,y:65,z:70},{x:25,y:85,z:80},{x:75,y:85,z:80},{x: 75,y:65,z:70},

    //TigeHaute
    {move:{x: 85,y:-80, z:0}},{x: 85,y:-80, z:-20},{x: 85,y:-60, z:-20},{x: 85,y:-60, z:0},
    {x: 85,y:-80, z:0},{x: -85,y:-80, z:0},{x: -85,y:-60, z:0},{x: 85,y:-60, z:0}, //Point D"
  ],
  stroke: 2,
  color:'#001133',
})

boitier3d.copy({
  addTo: Boitier3DPrintGroupTitle,
});

//La bobine en plusieurs parties
let ExterneDisqueBobine = new Zdog.Ellipse({
  addTo: fabIcon,
  width: 55, height: 55,
  stroke: 2, color: '#EA4536',
  translate: {x:-30,y:-90,z:-20},
})
ExterneDisqueBobine.copy({
  width:15, height:15,
})
ExterneDisqueBobine.copy({
  quarters:2, translate: {x:-30,y:-90,z:-40},
})

ExterneDisqueBobine.copy({
  addTo: fabIconTitle,
})

ExterneDisqueBobine.copy({
  addTo: fabIconTitle,
  width:15, height:15,
})
ExterneDisqueBobine.copy({
  addTo: fabIconTitle,
  quarters:2, translate: {x:-30,y:-90,z:-40},
})

let lineBobine = new Zdog.Shape({
  addTo: fabIcon,
  path: [
    {x:-30,y:-117.5,z:-20}, // start at 1st point
    {x:-30,y:-117.5,z:-40}, // line to 2nd point
  ],
  stroke: 2,
  color: '#EA4536',
});

lineBobine.copy({
  translate:{y:55},
})

lineBobine.copy({
  addTo: fabIconTitle,
});

lineBobine.copy({
  addTo: fabIconTitle,
  translate:{y:55},
});

let buseGroup = new Zdog.Group({
  addTo:Boitier3DPrintGroup,
})

let buseGroupTitle = new Zdog.Group({
  addTo:Boitier3DPrintGroupTitle,
})

rectHide.copy({
  addTo:buseGroup,
  width:170, height:10,
  translate:{x: 0,y:5, z:10},
  color:'#DAD4D4', fill:true,
})

rectHideTitle.copy({
  addTo:buseGroupTitle,
  width:170, height:10,
  translate:{x: 0,y:5, z:10},
  color:'#DAD4D4', fill:true,
});

let axeZ = new Zdog.Shape({
  addTo: buseGroup,
  closed:false,
  path:[
    //axe ABCDAEFD
    {x: 85,y:0, z:10}, {x: 85,y:0, z:0}, {x: 85,y:10, z:0}, {x: 85,y:10, z:10},
    {x: 85,y:0, z:10}, {x: -85,y:0, z:10},{x: -85,y:10, z:10}, {x: 85,y:10, z:10},
  ],
  stroke: 2,
  color:'#001133',
})

axeZ.copy({
  addTo:buseGroupTitle,
});


let rectFillBuse = new Zdog.Rect({
  addTo:buseGroup,
  width:20, height:30,
  translate:{x: 0,y:5, z:19},
  color:'#DAD4D4', fill:true,
})

rectFillBuse.copy({
  addTo:buseGroupTitle,
});

let buse = new Zdog.Shape({
  addTo: buseGroup,
  closed:false,
  path:[
    //buse ABCDAEFD
    {x: 10,y:-10, z:20}, {x: 10,y:-10, z:10}, {x: 10,y:20, z:10}, {x: 10,y:20, z:20},
    {x: 10,y:-10, z:20}, {x: -10,y:-10, z:20},{x: -10,y:20, z:20},{x: 10,y:20, z:20},
  ],
  stroke: 2,
  color: '#EA4536',
})

buse.copy({
  addTo:buseGroupTitle,
});

export {fabIcon, fabIconTitle};

///////////////////////////////////
/////// FIN ICONE IMPRIMANTE 3D ///
///////////////////////////////////

////////////////////////////////////
//          ELEC ICON             //
////////////////////////////////////

let elecElem = document.querySelector("#elecIcon");
let elecTitleElem = document.querySelector("#elecIconTitle");

let elecIcon = new Zdog.Illustration({
  element: elecElem,
  scale: 0.3,
});

let elecTitle = new Zdog.Illustration({
  element: elecTitleElem,
  scale: 0.3,
});

let elecGroup = new Zdog.Group({
  addTo: elecIcon,
});

let elecTitleGroup = new Zdog.Group({
  addTo: elecTitle,
});

let arrDrone = new Zdog.Shape({
  addTo: elecGroup,
  closed: false,
  path: [
    { x: 40, y: 50, z:30 }, // start at 1st point
    {arc: [
        { x: 0, y:60 , z:30 }, // corner
        { x: -40, y: 50, z:30 }, // end point
      ]},
    {arc: [
        { x: -50, y: 0, z:30 }, // corner
        { x: -40, y: -50, z:30 }, // end point
      ]},
    {arc: [
        { x: 0, y:-60 , z:30 }, // corner
        { x: 40, y: -50, z:30 }, // end point
      ]},
    {arc: [
        { x: 50, y: 0, z:30 }, // corner
        { x: 40, y: 50, z:30 }, // end point
      ]},
  ],
  translate: { x: 0, y: 0, z: -30 },
  fill: false,
  color: '#001133',
  stroke: 3,
});

arrDrone.copy({
  addTo: elecTitleGroup,
});

let pale = new Zdog.Shape({
  addTo: elecGroup,
  closed: false,
  path: [
    { x: 40, y: -50, z:15 }, // start at 1st point
    { x: 90, y: -80, z:15 }, // line to 2nd point
  ],
  stroke: 3,
  color: '#ea4536',
});

pale.copy({
  addTo: elecTitleGroup,
});

let pale2 = new Zdog.Shape({
  addTo: elecGroup,
  closed: false,
  path: [
    { x: -40, y: -50, z:15 }, // start at 1st point
    { x: -90, y: -80, z:15 }, // line to 2nd point
  ],
  stroke: 3,
  color: '#ea4536',
});

pale2.copy({
  addTo: elecTitleGroup,
});

let pale3 = new Zdog.Shape({
  addTo: elecGroup,
  closed: false,
  path: [
    { x: 40, y: 50, z:15 }, // start at 1st point
    { x: 90, y: 80, z:15 }, // line to 2nd point
  ],
 stroke: 3,
  color: '#ea4536',
});

pale3.copy({
  addTo: elecTitleGroup,
});

let pale4 = new Zdog.Shape({
  addTo: elecGroup,
  closed: false,
  path: [
    { x: -40, y: 50, z:15 }, // start at 1st point
    { x: -90, y: 80, z:15 }, // line to 2nd point
  ],
  stroke: 3,
  color: '#ea4536',
})

pale4.copy({
  addTo: elecTitleGroup,
});

let fillAvtDrone = new Zdog.Shape({
  addTo: elecGroup,
  closed: false,
  path: [
    { x: 40, y: 50, z:30 }, // start at 1st point
    {arc: [
        { x: 0, y:60 , z:30 }, // corner
        { x: -40, y: 50, z:30 }, // end point
      ]},
    {arc: [
        { x: -50, y: 0, z:30 }, // corner
        { x: -40, y: -50, z:30 }, // end point
      ]},
    {arc: [
        { x: 0, y:-60 , z:30 }, // corner
        { x: 40, y: -50, z:30 }, // end point
      ]},
    {arc: [
        { x: 50, y: 0, z:30 }, // corner
        { x: 40, y: 50, z:30 }, // end point
      ]},
  ],
  fill: true,
  color: '#dad4d4',
});

fillAvtDrone.copy({
  addTo: elecTitleGroup,
});

let avtDrone = fillAvtDrone.copy({
  fill: false,
  stroke: 3,
  color: '#001133',
});

avtDrone.copy({
  addTo: elecTitleGroup,
});


let helice = new Zdog.Group({
  addTo: elecGroup,
  translate: { z: 30 },
});

let heliceTitle = new Zdog.Group({
  addTo: elecTitleGroup,
  translate: { z: 30 },
});

let helice1 = new Zdog.Shape({
  addTo: helice,
  closed: false,
  path: [
    { x: 0, y: 0 }, // start at 1st point
    { x: 0, y: 40 }, // line to 2nd point
    {move: { x: 20, y: 20 }},
    {line: { x: -20, y: 20 }},
    {move: { x: 0, y: 20 }},
    {line: { x: 0, y: 20, z: -20 }},

  ],
  translate: { x: 90, y: -100, z:5 },
  stroke: 2,
  color: '#001133',
});

helice1.copy({
  addTo: heliceTitle,
});

let helice2 = helice1.copy({
  translate: { x: -90, y: -100, z:5 },
});

helice2.copy({
  addTo: heliceTitle,
});

let helice3 = helice1.copy({
  translate: { x: 90, y: 60, z:5 },
});

helice3.copy({
  addTo: heliceTitle,
});

let helice4 = helice1.copy({
  translate: { x: -90, y: 60, z:5 },
});

helice4.copy({
  addTo: heliceTitle,
});

export {elecIcon, elecTitle};

////////////////////////////////////
//          FIN ELEC ICON         //
////////////////////////////////////

////////////////////////////////////
//          COLLAB ICON          //
////////////////////////////////////

let collabElem = document.querySelector('#collabIcon');
let collabTitleElem = document.querySelector('#collabIconTitle');

let collabIcon = new Zdog.Illustration({
  element: collabElem,
  scale: 0.18,
})

let collabTitle = new Zdog.Illustration({
  element: collabTitleElem,
  scale: 0.18,
});

let collabGroup = new Zdog.Group({
  addTo: collabIcon,
});

let collabTitleGroup = new Zdog.Group({
  addTo: collabTitle,
});

let person = new Zdog.Group({
  addTo: collabGroup,
  translate:{x:110},
})

let personTitle = new Zdog.Group({
  addTo: collabTitleGroup,
  translate:{x:110},
})


//visage
let faceCollab = new Zdog.Ellipse({
  addTo: person,
  fill:true, color:'#D4D4D4',
  diameter: 130,

})
faceCollab.copy({
  fill:false,
  stroke: 3, color: '#001133',
})

faceCollab.copy({
  addTo: personTitle,
})

faceCollab.copy({
  addTo: personTitle,
  fill:false,
  stroke: 3, color: '#001133',
});

//bodyCollab
let  bodyCollab= new Zdog.Shape({
  addTo: person,
  closed:false,
  path:[
    {x:-10,y:80,z:0},{x:10,y:80,z:0},
    { arc: [
        { x:  100, y: 80 },{ x:  100, y:  180 },
      ]},
    {x:-100, y:180},
    { arc: [
        { x:  -100, y: 80 },{ x:  -10, y:  80 },
      ]},

  ],
  stroke: 3, color:'#EA5435', scale:{x:0.8},
})

bodyCollab.copy({
  addTo: personTitle,
});

person.copyGraph({
  translate:{x:-110},
})

personTitle.copyGraph({
  translate:{x:-110},
});


let ampoule = new Zdog.Group({
  addTo:collabGroup,
  scale:0.6,rotate:{y:Zdog.TAU/4},
  translate:{y:-80,z:0},

})

let ampouleTitle = new Zdog.Group({
  addTo:collabTitleGroup,
  scale:0.6,rotate:{y:Zdog.TAU/4},
  translate:{y:-80,z:0},
});

let cercleFil = new Zdog.Ellipse({
  addTo:ampoule,
  diameter:20,
  translate:{x:-30,y:-120},
  stroke: 3,color:'#EA4536',
})
cercleFil.copy({
  translate:{x:40,y:-110},
})

cercleFil.copy({
  addTo:ampouleTitle,
  translate:{x:-30,y:-120},
  stroke: 3,color:'#EA4536',
})

cercleFil.copy({
  addTo:ampouleTitle,
  translate:{x:40,y:-110},
})

//fil
let fil = new Zdog.Shape({
  addTo: ampoule,
  closed:false,
  path:[
    {x:10,y:50,z:0},{x:10,y:-40,z:0},
    {x:40,y:-60,z:0},{x:40,y:-100,z:0},
    {x:0,y:-100,z:0},{x:10,y:-70,z:0},
    {x:-30,y:-110,z:0},{x:-30,y:-40,z:0},

    {x:-10,y:0,z:0},{x:-10,y:50,z:0},

    {move:{x:-30,y:80,z:0}},{x:30,y:80,z:0},{x:-20,y:100,z:0},
    {move:{x:20,y:100,z:0}},{x:-10,y:120,z:0},{x:0,y:130,z:0},
  ],
  stroke: 3,color:'#EA4536',
})

fil.copy({
  addTo:ampouleTitle,
});

//bulb
let bulb = new Zdog.Shape({
  addTo: ampoule,
  closed:false,
  path:[
    {x:-40,y:60,z:0},{x:40,y:60,z:0},{x:40,y:20,z:0},
    {arc:[{x:40,y:-10,z:0},{x:60, y:-25,z:0},]},
    {arc:[{x:100, y:-50,z:0},{x:100,y:-100,z:0},]},
    {x:100, y:-100,z:0},
    {arc:[{x:100, y:-200,z:0},{x:0,y:-200,z:0},]},

    {arc:[
        {x:-100,y:-200,z:0},{x:-100, y:-100,z:0},]},
    {move:{x:-40,y:60,z:0}},{x:-40,y:20,z:0},
    {arc:[{x:-40,y:-10,z:0},{x:-60, y:-25,z:0},]},
    {arc:[{x:-100, y:-50,z:0},{x:-100,y:-100,z:0},]},
  ],
  stroke: 3,color:'#001133',
})

bulb.copy({
  addTo:ampouleTitle,
});

export {collabIcon, collabTitle};

////////////////////////////////////
//          FIN COLLAB ICON       //
////////////////////////////////////

///////////////////////////////////
/////// ICONS CONTACT   ///////////
///////////////////////////////////

let contactElem = document.querySelector('#contactIcon');

let contactIcon = new Zdog.Illustration({
  element: contactElem,
  scale: 0.4,
  translate: {y: 10},
})

let contactGroup = new Zdog.Group({
  addTo: contactIcon,
})

let bordFondEnveloppe = new Zdog.Shape({
  addTo: contactGroup,
  path:[
    {x:-80,y:-70,z:-30},{x:-80,y:30,z:-30},{x:80,y:30,z:-30},{x:80,y:-70,z:-30},
  ],
  stroke: 3,
  color: '#001133',
})

let bordEnveloppeFill = new Zdog.Shape({
  addTo: contactGroup,
  closed:false,
  path:[
    {x:-80,y:-70,z:0},{x:-80,y:30,z:0},{x:80,y:30,z:0},{x:80,y:-70,z:0},
  ],
  stroke: 3,
  color: '#dad4d4',
  fill:true,
})

let bordEnveloppe= bordEnveloppeFill.copy({
  fill:false,
  stroke: 3,
  color: '#001133',
})

//enveloppe
let enveloppe = new Zdog.Shape({
  addTo: contactGroup,
  path:[
    {x:-80,y:-70,z:0},{x:0,y:-10,z:0},{x:80,y:-70,z:0},
  ],
  stroke: 3,
  color: '#ea4536',
})


let timbreFill = new Zdog.Ellipse({
  addTo: contactGroup,
  diameter: 30,
  translate: {y:-10},
  fill: true,
  color: '#dad4d4',
})

let timbre = timbreFill.copy({
  fill: false,
  stroke: 3,
  color: '#001133',
})

// fais moi un C dans le timbre
let cTimbre = new Zdog.Ellipse({
  addTo: contactGroup,
  diameter: 15,
  quarters: 2,
  translate: {x: 2, y:-10},
  rotate: {z: Zdog.TAU/2},
  stroke: 3,
  color: '#ea4536',
})

let cTimbre2 = cTimbre.copy({
  translate: {x: 2, y:-10, z: 5},
})

let cTimbre3 = cTimbre.copy({
  translate: {x: 2, y:-10, z: 10},
})



contactIcon.updateRenderGraph();
export {contactIcon};

///////////////////////////////////
/////// FIN ICONS CONTACT   //////
///////////////////////////////////


// Function to handle event listeners
function handleEventListeners(listeLi, indicator,width) {
  //divise la width de la navbar par le nombre de li
  for (let i = 0; i < listeLi.length; i++) {
    listeLi[i].addEventListener('click', function () {
      let offsetLeft = this.offsetLeft;
      console.log(offsetLeft);
      indicator.style.left = offsetLeft + 'px';
    });
  }
}

// Simplified code
document.addEventListener('DOMContentLoaded', function () {
  let navBar = document.querySelector('.navbar');
  let navIcon = document.querySelectorAll('.navIcon');
  let iconTitle = document.querySelectorAll('.iconTitle');
  let logoDiv = document.querySelector('#logo-div');

  let logoCharly = document.querySelector('#logo-CharlyLab');

  if (window.innerWidth <= 850) {
    navBar.classList.replace('navbar', 'navbarMin');
    navIcon.forEach((item) => {
      let iconmin= document.createElement('img');
      item.classList.remove('navIcon');
      item.classList.add('navIconMin');
      iconmin.id=item.children[0].id;
      iconmin.src = "./svg/"+item.children[0].id+"-min.svg";
      iconmin.alt = item.children[0].id;
      item.replaceChild(iconmin,item.children[0]);
    });

    logoCharly.remove();
    let svgToImg = document.createElement('img');
    svgToImg.id = "logo-CharlyLab";
    svgToImg.src = "./texture/LogoNB.svg";
    svgToImg.alt = "Logo Charly Lab";
    logoDiv.appendChild(svgToImg);

    let listeLi = navBar.children[1].children;
    let indicator = document.querySelector('.indicator');
    let width = 100 / listeLi.length;
    handleEventListeners(listeLi, indicator,width);

    let svg = document.querySelector('#Calque_1');
    svg.remove();
  }
});

const list = document.querySelectorAll('.navLi');
list.forEach((item) => item.addEventListener('click', function () {
  list.forEach((item) => item.classList.remove('active'));
  this.classList.add('active');
}));